import type { FunctionComponent } from 'react';
import {
  boolean,
  object,
  partial,
  optional,
  string,
  any,
  record,
  func,
  Struct,
} from 'superstruct';

/*
 * we can't import types from @leagueplatform/claims-api because of
 * cyclic dependencies, so we're defining a barebones version of PartialClaimData here.
 */
type Value = {
  amount: number;
  currencyCode: string;
};

type PartialClaimData = {
  claimType: string;
  status: string;
  createdDate?: string;
  paidDate?: string;
  serviceDate: string;
  charged: Value;
  memberDiscount?: Value;
  otherInsurancePaid?: Value;
  owed?: Value;
  planPaid?: Value;
  providerServiceNetwork: string;
};

export const claimsConfigSchema = object({
  filterableProperties: optional(record(string(), any())),
  featureFlags: optional(
    partial(
      object({
        shouldShowClaimDetails: boolean(),
        shouldShowDownloadClaims: boolean(),
        shouldShowFilterChips: boolean(),
      }),
    ),
  ),
  supportLink: optional(string()),
  showTotalCostOverviewAndAdditionalResources: optional(boolean()),
  showAdditionalResources: optional(boolean()),
  showClaimStatusDefinitions: optional(boolean()),
  showClaimsSummaryBackButton: optional(boolean()),
  enableDynamicFilters: optional(boolean()),
  enableTabFilters: optional(boolean()),
  getTotalCostOverviewVisibilityForClaim: optional(
    func() as unknown as Struct<(claim: PartialClaimData) => boolean>,
  ),
  slots: optional(
    object({
      Banner: optional(func() as unknown as Struct<FunctionComponent>),
      ServiceDetailsBanner: optional(
        func() as unknown as Struct<FunctionComponent>,
      ),
    }),
  ),
  showHealthInsuranceGlossary: optional(boolean()),
  healthInsuranceGlossaryLink: optional(string()),
});
